<template>
  <TheHeader />
  <router-view />
  <TheFooter />
  <CookieConsent />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import TheHeader from '@/components/layout/TheHeader/Index.vue'
import TheFooter from '@/components/layout/TheFooter/Index.vue'
import CookieConsent from '@/components/global/CookieConsent/Index.vue'

export default defineComponent({
  name: 'App',
  components: { TheHeader, TheFooter, CookieConsent }
})
</script>

<style lang="scss"></style>